import { useTranslation } from "react-i18next";

const problems = [
  { key: "seminars.problems.card1", icon: "ri-landscape-line" },
  { key: "seminars.problems.card2", icon: "ri-money-cny-circle-line" },
  { key: "seminars.problems.card3", icon: "ri-file-paper-line" },
  { key: "seminars.problems.card4", icon: "ri-time-line" },
  { key: "seminars.problems.card5", icon: "ri-home-4-line" },
  { key: "seminars.problems.card6", icon: "ri-hammer-line" },
];

export default function ProblemsSection() {
  const { t } = useTranslation();

  return (
    <section className="section-padding bg-cream">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="tag-label mb-4 inline-block">{t("seminars.problems.label")}</span>
          <h2 className="mb-4">{t("seminars.problems.title")}</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {problems.map((p) => (
            <div
              key={p.key}
              className="bg-white rounded-xl p-6 md:p-7 border border-warm-gray/60 transition-all duration-300 hover:translate-y-[-4px]"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-champagne/10 mb-5">
                <i className={`${p.icon} text-xl text-champagne`} />
              </div>
              <p className="font-sans font-semibold text-graphite text-[1.0625rem] mb-0 leading-relaxed">
                {t(p.key)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}